export const CustomRegex = {
  alphaNumeric: /^[A-Za-z0-9]+$/,
  alphaNumericPunctuation: /^[A-Za-z0-9:_/*\\\-;,'. ]+$/,
  alphaNumericPunctuationAmpersand: /^[A-Za-z0-9:_/*\\\-;,.&' ]+$/,
  alphaNumericSpecialChars: /^[A-Za-z0-9:_/*\\\-;,.&' ~`!@#$%^()_=+:<>"?\n ]+$/,
  date: /^\d{4}-\d{2}-\d{2}/,
  email: /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/,
  firstLastName: /^[a-zA-Z]+$/,
  displayedMobileNumber: /^\d{3}-\d{3}-\d{4}$/,
  mobileNumber: /^\+1\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
  numeric: /^[0-9]+$/,
  positiveAndNegativeNumbers: /^-?\d+$/,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/,
  userName: /^[a-zA-Z0-9@._-]{8,}$/,
  usPostalCode: /^\d{5}(-\d{4})?$/,
  caPostalCode: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/,
  lonLat: /^-?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*-?(180(\.0+)?|((1[0-7]\d)|(\d{1,2}))(\.\d+)?)$/,
  taskDetailsPage: /^\/(driver\/)?yard-operations\/tasks\/[a-fA-F0-9-]+$/,
  settingsPage: /^\/sites(?:\/.*)?$/,
  spotRange: /^(\d+|\d+-\d+)(,(\d+|\d+-\d+))*$/,
};
